import { logger } from 'helpers'
import Header from './Header'
import Sidebar from './Sidebar'
import AlertHandler from './AlertHandler'
import CommandPalette from './CommandPalette'
import DashboardBox from './DashboardBox'
import OfflineIndicator from './OfflineIndicator'

var core = {}
try {
  core = require('../../projects/' + process.env.REACT_APP_PROJECT + '/components/core/index.js')
} catch (e) {
  logger.debug('No project-specific core components')
}

module.exports = {
  Header,
  Sidebar,
  AlertHandler,
  CommandPalette,
  DashboardBox,
  OfflineIndicator,
  ...core
}



// WEBPACK FOOTER //
// ./src/components/core/index.js